import type { FC } from "react";
import type React from "react";

import classNames from "classnames";

import { UiCheckIcon } from "@jti/brand-icons/ui-check";

import styles from "./ProgressBarRewardBadge.module.scss";

type ProgressBarRewardBadgeProps = {
  mileStoneHeading: React.ReactNode;
  milestonesText: string;
  className?: string;
  isDone: boolean;
  isLast: boolean;
};

export const ProgressBarRewardBadge: FC<ProgressBarRewardBadgeProps> = ({
  isDone,
  mileStoneHeading,
  milestonesText,
  className,
  isLast,
}) => {
  return (
    <div
      data-testid="rewardBadge"
      className={classNames(styles.rewardBadgeWrapper, className, {
        [styles.rewardBadgeWrapperDone]: isDone,
        [styles.rewardBadgeWrapperIsLast]: isLast,
      })}
    >
      <div className={styles.rewardBadgeHeaderContainer}>
        <h3 className={styles.rewardBadgeWrapperHeading}>+{mileStoneHeading}</h3>
        {isDone && <UiCheckIcon className={styles.rewardBadgeWrapperIcon} width="15" height="15" />}
      </div>
      <div className={styles.rewardBadgeWrapperText}>{milestonesText}</div>
    </div>
  );
};
